import React from "react"
import autobind from "class-autobind"
import { EScheduleListType, IScheduleDocument } from "../../../models"
import strings from "../../../localization/strings"
import DonutChart from "../../common/donutChart/DonutChart"
import AccountStore from "../../../stores/AccountStore"
import { FontIcon, Card, RaisedButton } from "material-ui"
import ScheduleBudgetCostSavingsDrawer from "./ScheduleBudgetCostSavingsDrawer"
import numeral from "numeral"

interface IProps {
  schedule: IScheduleDocument
}

interface IState {
  showSavingsDrawer: boolean
}

export default class ScheduleBudgetDetail extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      showSavingsDrawer: false
    }
    autobind(this)
  }

  getStaffingInfoLabelColumn(label, number) {

    if (number && number > 0) {
      return <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>{label}: </b></div>
    }
  }

  getStaffingInfoValueColumn(number) {
    if (number && number > 0) {
      return <div style={{ gridRow: "auto", gridColumn: 2 }}>{Math.round(100 * number)}%</div>
    }
  }

  render() {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    const totalShiftsCount = this.props.schedule.Schedules.length
    const unfilledShiftsCount = this.props.schedule.Schedules.filter(pt => !pt.AssignedUserId).length
    const filledPercent = totalShiftsCount === 0 ? 0 : Math.round((totalShiftsCount - unfilledShiftsCount) * 100 / totalShiftsCount)
   
    let redMarginColor = undefined
    if (this.props.schedule.Summary && this.props.schedule.Summary.BudgetSummary) {
      if (this.props.schedule.Summary.BudgetSummary.Margin < 20) {
        redMarginColor = "#f44336"
      }
    }
   
    let agencyInfo = <div></div>
    if (this.props.schedule.Summary && this.props.schedule.Summary.BudgetSummary && AccountStore.getCRMEnabled()) {
     
      agencyInfo =
        <div style={{ padding: 20, display: "grid" }}>
          {this.getStaffingInfoLabelColumn("Core Staff", this.props.schedule.Summary.FilledByCore)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByCore)}
          {this.getStaffingInfoLabelColumn("Float Staff", this.props.schedule.Summary.FilledByFloat)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByFloat)}
          {this.getStaffingInfoLabelColumn("Per Diem Staff", this.props.schedule.Summary.FilledByPerDiem)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByPerDiem)}
          {this.getStaffingInfoLabelColumn("Agency Staff", this.props.schedule.Summary.FilledByAgency)}{this.getStaffingInfoValueColumn(this.props.schedule.Summary.FilledByAgency)}
        </div>
    }
    
    return (
        <div style={{padding: 20, textAlign: "center", display: "grid"}}>
          {!AccountStore.getMedicalAccount() && 
            <div style={{gridColumn: 1}}>
              <DonutChart
                value={filledPercent}
                strokeWidth={10}
                size={125}
                valuelabel={strings.Filled.toUpperCase()}
                textValStyle={{ fontSize: 25 }}
                percentStyle={{ fontSize: 25 }}
                textLabelStyle={{ fontSize: 13 }}
                spaceBetweenValAndLabel={20}
              />
            </div>
          }
          {AccountStore.getMedicalAccount() && 
            <div style={{gridColumn: 2}}>
              <h3>Staff Plan Summary</h3>
              <div style={{display: "grid"}}>
                <div style={{gridRow: 1, gridColumn: 1}}>
                  <DonutChart
                    value={this.props.schedule.Budget.ScheduleBudgetInfo && this.props.schedule.Budget.ScheduleBudgetInfo.FillRateInfo ? (Math.round(this.props.schedule.Budget.ScheduleBudgetInfo.FillRateInfo.FillRate * 100)): 0}
                    strokeWidth={5}
                    size={100}
                    valuelabel={strings.FillRate.toUpperCase()}
                    textValStyle={{ fontSize: 25 }}
                    percentStyle={{ fontSize: 15 }}
                    textLabelStyle={{ fontSize: 12 }}
                    spaceBetweenValAndLabel={15}
                  /> 
                </div>    
                <div style={{gridRow: 1, gridColumn: 2}}>
                  <DonutChart
                    value={this.props.schedule.Budget.ScheduleBudgetInfo && this.props.schedule.Budget.ScheduleBudgetInfo.FTEUtilizationInfo ? Math.round(this.props.schedule.Budget.ScheduleBudgetInfo.FTEUtilizationInfo.Utilization * 100) : 0}
                    strokeWidth={5}
                    size={100}
                    valuelabel={"Utilization".toUpperCase()}
                    textValStyle={{ fontSize: 25 }}
                    percentStyle={{ fontSize: 15 }}
                    textLabelStyle={{ fontSize: 12 }}
                    spaceBetweenValAndLabel={15}
                  /> 
                </div> 
                <div style={{gridRow: 1, gridColumn: 3}}>
                  <DonutChart
                    value={this.props.schedule.Budget.ScheduleBudgetInfo && this.props.schedule.Budget.ScheduleBudgetInfo.OvertimeInfo ? Math.round(this.props.schedule.Budget.ScheduleBudgetInfo.OvertimeInfo.OvertimePercentageOfWhole *100): 0}
                    strokeWidth={5}
                    size={100}
                    valuelabel={"Overtime".toUpperCase()}
                    textValStyle={{ fontSize: 25 }}
                    percentStyle={{ fontSize: 15 }}
                    textLabelStyle={{ fontSize: 12 }}
                    spaceBetweenValAndLabel={15}
                  /> 
                </div>                                   
               </div>
                <div style={{textAlign: "left"}}>
                  {agencyInfo}
                </div>
                {this.props.schedule.Budget && this.props.schedule.Budget.ScheduleBudgetInfo && this.props.schedule.Budget.ScheduleBudgetInfo.SavingsPotential && 
                  <Card className="costSavings" style={{padding: 30, borderRadius: 15, border: "solid 1px #efefef", cursor: "pointer" }} onClick={()=>{
                      this.setState({showSavingsDrawer: true})
                  }}>
                    <div style={{display: "grid", alignItems: "center", gridTemplateColumns: "auto min-content",}}>
                      <div style={{gridColumn: 1, gridRow: 1}}>
                        <div style={{fontSize: 35}}>
                          <b>
                            {numeral(this.props.schedule.Budget.ScheduleBudgetInfo.SavingsPotential.TotalSavings).format('$0.0a')}
                          </b>
                        </div>
                        <div style={{fontSize: 12, marginTop: 5}}>{strings.PotentialCostSavings}</div>                   

                        <div style={{fontSize: 12, marginTop: 20}}><b>Total Schedule Cost:</b> {numeral(this.props.schedule.Budget.ScheduleBudgetInfo.ScheduleCost.TotalCost).format('$0.0a')}</div>
                      </div>
                      <div style={{gridColumn: 2, gridRow: 1}}>
                        <i className="fa fa-info-circle" style={{fontSize: 15}} />
                      </div>
                    </div>
                  </Card>            
                }
              </div>
          }
          {this.props.schedule.Budget && this.props.schedule.Budget.ScheduleBudgetInfo && this.props.schedule.Budget.ScheduleBudgetInfo.SavingsPotential && 
            <ScheduleBudgetCostSavingsDrawer 
              name={this.props.schedule.Name} 
              startDate={this.props.schedule.StartDate}
              endDate={this.props.schedule.EndDate}
              bi={this.props.schedule.Budget.ScheduleBudgetInfo}
              open={this.state.showSavingsDrawer} 
              handleClose={()=> this.setState({showSavingsDrawer: false})}
            />
          }
        </div>
    )
  }
}